import { render, staticRenderFns } from "./ComandaServicesReact.vue?vue&type=template&id=51d225b2&"
import script from "./ComandaServicesReact.vue?vue&type=script&lang=js&"
export * from "./ComandaServicesReact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports